<template>
    <v-avatar :size="size"
              color="orange"
              class="mr-2"
              v-bind="$attrs"
              @click="$emit('click', $event)"
    >
        <img v-if="has_avatar" alt="" :src="'/avatars/' + AVATAR"/>
        <span v-else class="white--text text-h6">{{INITIALS}}</span>
    </v-avatar>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "Avatar",
    props: {
        size: {
            type: Number,
            default: 40
        },
    },
    computed:{
        ...mapGetters('user', ['AVATAR', 'INITIALS']),
        has_avatar(){
            return null !== this.AVATAR;
        }
    }
}
</script>

<style scoped>

</style>